import { render, staticRenderFns } from "./ModalIndicacaoMgm.vue?vue&type=template&id=78024094&scoped=true"
import script from "./ModalIndicacaoMgm.vue?vue&type=script&lang=js"
export * from "./ModalIndicacaoMgm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78024094",
  null
  
)

export default component.exports